import { useEffect, useRef } from 'react';
import type { MutableRefObject } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

export function useTrackCommentsImpression(containerRef: MutableRefObject<HTMLElement | null>, enabled: boolean): void {
	const trackedRef = useRef(false);
	const track = useTracking();

	useEffect(() => {
		if (!enabled || trackedRef.current) return;

		if (containerRef.current) {
			trackedRef.current = true;
			void track('petition_comments_view');
		}
	}, [containerRef, enabled, track]);
}
